const Empty = () => {
  return null
}

export default Empty
